import React, { useRef, useState, useEffect } from 'react'
import { Typography } from '@mui/material'
import LockingTooltip from '../LockingTooltip'

const MultilineEllipsisWithTooltip = ({ text = '', maxLines = 3 }) => {
  const ref = useRef(null)
  const [isOverflowed, setIsOverflowed] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (el) {
      const overflow = el.scrollHeight > el.clientHeight + 1
      setIsOverflowed(overflow)
    }
  }, [text])

  return (
    <LockingTooltip
      title={
        isOverflowed ? (
          <Typography
            sx={{
              maxHeight: 300,
              overflowY: 'auto',
              whiteSpace: 'pre-line',
              fontSize: '12px',
              minWidth: 50,
            }}
          >
            {text}
          </Typography>
        ) : (
          ''
        )
      }
      arrow
      disableHoverListener={!isOverflowed}
    >
      <Typography
        ref={ref}
        variant="body2"
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: maxLines,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'pre-line',
          color: '#4b4f60',
          fontWeight: 600,
          fontSize: '12px',
          wordBreak: 'keep-all',
        }}
      >
        {text}
      </Typography>
    </LockingTooltip>
  )
}

export default MultilineEllipsisWithTooltip
